var React = require('react');

function IconMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.56 3.392l.532-.442H26.4 5.6h-.692l.532.442 10.4 8.64.16.133.16-.133 10.4-8.64zM2.95 19.2v.25h.25 25.6.25v-.25V5.44v-.53l-.409.337-11.84 9.76-.009.008-.008.008c-.037.037-.15.102-.322.16a1.58 1.58 0 0 1-.461.087c-.316 0-.541-.005-.783-.247l-.008-.008-.009-.008-11.84-9.76-.409-.337v.53V19.2zM3.2.25h25.6a2.96 2.96 0 0 1 2.95 2.95v16a2.96 2.96 0 0 1-2.95 2.95H3.2A2.96 2.96 0 0 1 .25 19.2v-16A2.96 2.96 0 0 1 3.2.25z"}));
}

IconMail.defaultProps = {"width":"32","height":"23","fill":"#34a853"};

module.exports = IconMail;

IconMail.default = IconMail;
